const element = document.createElement('canvas');
export const getSVGTextWidth = (txt, font) => {
  const context = element.getContext('2d');
  context.font = font;
  return context.measureText(txt).width;
};
